import { Box } from "@mui/material";
import React from "react";
import Template from "../Generico/Template";
import TituloPrincipal from "../Generico/TituloPrincipal";
import ConfiguracaoAgendamento from "./configuracaoAgendamento";
import ConfiguracaoFormatoEntrega from "./ConfiguracaoFormatoEntrega";
import ConfiguracaoValorMinimo from "./ConfiguracaoValorMinimo";
import ConfigurarEndereco from "./ConfigurarEndereco";
import ConfigurarTempoEntrega from "./configurarTempoEntrega";
import CupomDesconto from "./CupomDesconto";
import MensagemDelivery from "./MensagemDelivery";
import PermissaoMunicipio from "./permissaoMunicipio";

const Delivery = () => {
  return (
    <Template documentTitle="Configurações do delivery">
      <TituloPrincipal
        title="Configurações do delivery"
        subTitle="Configure as opções do seu delivery"
      />

      <Box mt={5}>
        <ConfigurarEndereco />
      </Box>

      <Box mt={5}>
        <MensagemDelivery />
      </Box>

      <Box mt={5}>
        <ConfigurarTempoEntrega />
      </Box>

      <Box mt={5}>
        <ConfiguracaoValorMinimo />
      </Box>

      <Box mt={5}>
        <ConfiguracaoFormatoEntrega />
      </Box>

      <Box mt={5}>
        <CupomDesconto />
      </Box>

      <Box mt={5}>
        <PermissaoMunicipio />
      </Box>

      <Box mt={5}>
        <ConfiguracaoAgendamento />
      </Box>
    </Template>
  );
};

export default Delivery;
